import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M 28.541667,61
              L 28.541667,30.3
              L 39.291667,30.3
              C 45.691667,30.3 49.691667,33.15 49.691667,38.65
              C 49.691667,42.95 47.941667,45.95 39.291667,46.15
              L 34.291667,46.15
              L 34.291667,61
              L 28.541667,61
              Z
              M 34.291667,42.2
              L 34.291667,34.2
              L 39.291667,34.2
              C 43.691667,34.2 44.691667,35.15 44.691667,38.65
              C 44.691667,41 43.691667,42.1 39.291667,42.2
              L 34.291667,42.2
              Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
